import routes from 'js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import { WorkWithMetadata } from '../shared/types';

export async function getWorksReadingHistory() {
  const response = await fetchWithCsrf(
    routes.for_work_api_v0_works_reading_history_path({
      subdomain_param: 'api',
    }),
  );
  if (response.status !== 200) {
    throw new Error('Failed to get reading history');
  }

  return (await response.json()) as {
    worksWithMetadata: {
      [id: number]: WorkWithMetadata;
    };
  };
}
